import React from "react";
import * as SC from "./TargetPerformance.styled";
import Card from "./../Card/Card";
import LinearChart from "../Charts/LinearChart/LinearChart";
import { useTranslation } from "react-i18next";

const GOOGLE_CHANNELS = ["google-display", "ebay-kleinanzeigen", "youtube", "google-search"];

/**
 * Check if the chart should be displayed, that is,
 * if it has any channels where the chart is implemented
 *
 * @param {Record<string, unknown>} chartData - The chart data
 * @returns {boolean} - Whether the chart should be displayed
 */
const shouldDisplay = (chartData) => {
  if (!chartData) return false;

  const hasMetaChannels = Boolean(chartData.facebook || chartData.instagram);

  const allKeys = Object.keys(chartData);
  const hasGoogleChannels = allKeys.some((key) => GOOGLE_CHANNELS.includes(key));
  const hasTiktokChannels = Boolean(chartData.tiktok);

  return hasMetaChannels || hasGoogleChannels || hasTiktokChannels;
};

const cardHeaderOptions = [
  { label: "CTR", value: "ctr" },
  { label: "Impressions", value: "impressions" },
  { label: "Clicks", value: "clicks" }
];

const TargetPerformance = ({ chartData }) => {
  const cardKey = "performanceMetrics";
  const { t } = useTranslation();

  const allKeys = Object.keys(chartData);
  const filteredKeys = allKeys.filter((key) => key !== "allChannelsAverage");

  if (!shouldDisplay(chartData)) {
    return <></>;
  }

  return (
    <Card
      cardKey={cardKey}
      title={t("Target Performance")}
      expandAttentionBox={false}
      options={cardHeaderOptions}
      channels={filteredKeys}
      fullWidth
    >
      <SC.MetricsWrapper>
        <LinearChart data={chartData} cardKey={cardKey} />
      </SC.MetricsWrapper>
    </Card>
  );
};

export default TargetPerformance;
